<IziPage>
  <IziGrid class="create-challenge">
    <IziCol xl="6" lg="6" md="12" class="setting-challenge-view">
      <SettingsChallenge />
    </IziCol>
    <IziCol xl="6" lg="6" md="12" class="preview-question-view">
     <div class="fixded-preview">
      <PreviewQuestion />
     </div>
    </IziCol>
    <IziCol class="action-setting-challenge">
      <IziGrid>
        <!-- <IziCol xl="2" lg="12" md="4" />
        <IziCol xl="2" lg="6" md="4" col="6" class="preview-quiz">
          <IziButton card="true" label="Preview" buttonType="primary" theme="outlined" />
        </IziCol> -->
        <IziCol xl="2" lg="6" md="4" col="6" class="publish-challenge">
          <IziButton @click="publishChallenge" card="true" label="Publish" buttonType="primary" theme="outlined" />
        </IziCol>
      </IziGrid>
    </IziCol>
  </IziGrid>
</IziPage>